<template>
  <div style="position:absolute;top:40%; width: 100%; font-size: 16px;">
    <div style="text-align: center;">登陆中...</div>
  </div>
</template>

<script>
import * as zlb from '../../router/zwjsbridge'
export default {
  data () {
    return {
      usertype: "",
      jwd: {},
      ticket: "",
      user: '',
    }
  },
  components: {
    zlb
  },
  props: {},
  created () {
    // this.$router.push({ path: '/index', replace: true })
    // this.$router.replace({ path: "/index" });
    var storage = window.localStorage;
    const sUserAgent = window.navigator.userAgent.toLowerCase();
    const bIsDtDreamApp = sUserAgent.indexOf("dtdreamweb") > -1; // 浙里办APP
    const bIsAlipayMini =
      sUserAgent.indexOf("miniprogram") > -1 &&
      sUserAgent.indexOf("alipay") > -1;
    if (bIsDtDreamApp) {
      //浙里办
      storage.setItem("hj", bIsDtDreamApp);
      this.watchApp();
    } else if (bIsAlipayMini) {
      //支付宝
      storage.setItem("hj2", bIsAlipayMini);
      this.watchApply();
    }
    let ticket = this.getQueryVariable("ticket");
    console.log("ticket");
    console.log(ticket);
    console.log("ticket-end");
    storage.setItem("ticket", ticket);
    this.ticket = ticket;
    //用户注册
    this.$api.getAPI("login/zlb/?token=0&appid=202108&type_id=4001", {
      st: ticket
    }).then(res => {
      console.log(res);
      this.user = res.data.data.data
      const uid = res.data.data.data.userid;
      window.sessionStorage.setItem('token', res.data.data.token.token);
      console.log(window.sessionStorage.getItem('token'));
      console.log(uid);
      console.log("add data");
      let user_model = {
        openid: uid
      }
      const rowObj = JSON.stringify(user_model)
      window.sessionStorage.setItem('user_model', rowObj);
      this.getzlb();
      this.getdian()
      this.$router.replace({ path: "/index" });
      // this.$router.push({ path: '/index', replace: true })
    })
    // const that = this
    // that.loadPageData()
  },
  mounted () {

    // window.localStorage.setItem('openid', 999999)
  },
  activated () {

  },
  methods: {
    //
    watchApp () {
      var that = this;
      window.addEventListener(
        "pageshow",
        function (event) {
          if (
            event.persisted ||
            (window.performance && window.performance.navigation.type == 2)
          ) {
            setTimeout(() => {
              ZWJSBridge.onReady(() => {
                ZWJSBridge.close();
              });
            }, 10);
          }
          that.isLoad();
        },
        false
      );
    },
    watchApply () {
      var that = this;
      window.addEventListener(
        "pageshow",
        function (event) {
          if (
            event.persisted ||
            (window.performance &&
              (window.performance.navigation.type == 1 ||
                window.performance.navigation.type == 0))
          ) {
            that.isLoad();
          } else if (
            event.persisted ||
            (window.performance && window.performance.navigation.type == 2)
          ) {
            my.navigateBack();
          } else {
            my.navigateBack(); //支付宝小程序的api，需在index.html引入，通过此api直接跳回浙里办小程序页面
          }
        },
        false
      );
    },
    isLoad () {
      if (!this.getQueryVariable("ticket")) {
        const sUserAgent = window.navigator.userAgent.toLowerCase();
        const bIsDtDreamApp = sUserAgent.indexOf("dtdreamweb") > -1; // 浙里办APP
        const bIsAlipayMini =
          sUserAgent.indexOf("miniprogram") > -1 &&
          sUserAgent.indexOf("alipay") > -1;
        if (bIsAlipayMini) {
          //改动
          window.location.href =
            "https://puser.zjzwfw.gov.cn/sso/alipay.do?action=ssoLogin&servicecode=yjz";
        } else {
          window.location.href =
            "https://puser.zjzwfw.gov.cn/sso/mobile.do?action=oauth&scope=1&servicecode=yjz";
        }
      }
    },
    //获取url参数
    getQueryVariable (variable) {
      var query = window.location.search.substring(1);
      console.log("query");
      console.log(query);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
        console.log("pair open");
        console.log(pair);
        console.log("pair end");
      }
      return false;
    },
    //埋点
    getdian () {
      console.log('开始埋点');
      (function (w, d, s, q, i) {
        w[q] = w[q] || [];
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s);
        j.async = true;
        j.id = "beacon-aplus";
        j.src = "https://d.alicdn.com/alilog/mlog/aplus.js?id=202951085";
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "aplus_queue");

      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["aplus-waiting", "MAN"],
      });
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["aplus-rhost-v", "alog.zjzwfw.gov.cn"],
      });

      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["aplus-rhost-g", "alog.zjzwfw.gov.cn"],
      });

      // 这个会落到app_key字段上
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["appId", "60506758"],
      });
      //应用开发管理平台miniAppId
      aplus_queue.push({
        action: "aplus.sendPV",
        arguments: [{
          is_auto: false,
        },
        {
          //改动
          miniAppId: "2001836404",
        },
        ],
      });
      //应用开发管理平台name
      aplus_queue.push({
        action: "aplus.sendPV",
        //改动
        arguments: ["miniAppName", "义家助"],
      });
      //  此时被block住的⽇志会携带上⽤户信息逐条发出
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_hold", "BLOCK"],
      });
      //经度
      aplus_queue.push({
        action: "aplus.sendPV",
        arguments: ["long", `${this.jwd.longitude}`],
      });
      //纬度
      aplus_queue.push({
        action: "aplus.sendPV",
        arguments: ["lati", `${this.jwd.latitude}`],
      });

      //用户类型
      aplus_queue.push({
        action: "aplus.sendPV",
        arguments: ["usertype", `${this.usertype}`],
      });

      // 设置⽤户昵称
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_user_nick", `${this.user.username}`],
      });
      // 设置⽤户ID
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_user_id", `${this.user.userid}`],
      });
      //  如采集⽤户信息是异步⾏为，需要先设置完⽤户信息后再执⾏这个START埋点

      //如采集⽤户信息是异步⾏为，需要先设置完⽤户信息后再执⾏这个START埋点
      // 此时被block住的⽇志会携带上⽤户信息逐条发出
      aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["_hold", "START"],
      });
    },
    // 浙里办api获取判断
    getzlb () {
      console.log('开始获取zlb相关数据');
      ZWJSBridge.onReady(() => {
        //获取用户类型
        ZWJSBridge.getUserType()
          .then((result) => {
            console.log("result1");
            console.log(result);
            console.log("result1-end");
            this.usertype = result.userType;
          })
          .catch((error) => {
            console.log(error);
          });
        //获取经纬度
        ZWJSBridge.getLocation().then((result) => {
          console.log("result2");
          console.log(result);
          console.log("result2-end");
          var jwd = result;
          this.jwd = jwd;
          var storage = window.localStorage;
          storage.setItem("city", jwd.city);
          storage.setItem("lat", jwd.latitude);
          storage.setItem("lon", jwd.longitude);
          console.log(storage.getItem("lat"));
        });
      });
    },
    //获取用户信息
    getuser () {
      var ticket = this.ticket;
      console.log("ticket");
      console.log(ticket);
      mgop({
        api: "mgop.yidian.zycx.http", // 必须
        data: {
          st: ticket,
        },
        type: "POST",
        appKey: "wrqys0ot+2001836404+rorzyk", // 必须，改动
        onSuccess: (data) => {
          console.log("data", data.data.data);
          var user = data.data.data;
          var storage = window.localStorage;
          storage.setItem("id", data.data.id);
          console.log(storage.getItem("id"));
          this.user = user;
          this.getzlb();
          this.getlist();
          console.log("user2");
          console.log(user);
          console.log("user2-end");
        },
        onFail: (err) => {
          console.log(err, "err");
        },
      });
    },
    loadPageData: function () {
      this.bug();
    },
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/login.vue